<template>
  <b-modal :id="'modal' + id" size="lg" centered hide-footer modal-class="sd-modal popup-modal" body-class="popup-body">
    <template #modal-header>
      <img
        class="sd-modal-logo"
        :src="$store.getters.isDarkMode ? require('@/assets/img/logo_santo_domingo_dark.png') : require('@/assets/img/logo_santo_domingo.png')"
        :alt="$root.constantes.logo_nombre_sitio"
      />
      <button type="button" class="sd-modal-close" aria-label="Cerrar" @click="closeModal">
        <span class="material-symbols-outlined">close</span>
      </button>
    </template>

    <component
      :is="popUp.url ? 'a' : 'div'"
      v-track:clic_aviso="{ aviso: popUp.titulo, url: popUp.url || undefined }"
      :href="popUp.url || null"
      class="popup-content"
      :class="{ 'is-link': popUp.url }"
    >
      <img :src="base + '/img/gallery/' + popUp.imagen" :alt="popUp.titulo || $root.constantes.nombre_sitio" />
      <span v-if="popUp.url" class="popup-cta">
        Más información <span class="material-symbols-outlined">arrow_forward</span>
      </span>
    </component>
  </b-modal>
</template>

<script>
import { track } from "@/directives/analitica.js";

export default {
  name: "PopUp",
  props: ["popUp", "id"],
  data() {
    return {
      base: this.$media,
    };
  },
  methods: {
    closeModal() {
      this.$bvModal.hide("modal" + this.id);
    },
  },
  mounted() {
    // Solo se muestra una vez cada 12 minutos por popup
    if (!this.$cookies.get(this.popUp.titulo)) {
      this.$cookies.set(this.popUp.titulo, "1", 60 * 60 * 0.2, "/");
      this.$bvModal.show("modal" + this.id);
      track("ver_aviso", { aviso: this.popUp.titulo });
    }
  },
};
</script>

<style scoped>
.popup-content {
  display: block;
  position: relative;
  text-decoration: none;
}

.popup-content img {
  display: block;
  width: 100%;
  border-radius: 14px;
}

.popup-content.is-link {
  cursor: pointer;
}

.popup-cta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 16px;
  height: 46px;
  border-radius: 999px;
  background: var(--sd-primary);
  font-weight: 600;
  color: var(--sd-primary-contrast);
  transition: background 0.15s;
}

.popup-content.is-link:hover .popup-cta {
  background: var(--sd-primary-strong);
}

.popup-cta .material-symbols-outlined {
  font-size: 20px;
  color: inherit;
}
</style>
